<template>
  <div class="edit-user gh-box" v-if="user">
    <v-layout row>
      <v-flex xs2 mr-4 right-align>
        <v-avatar size=200>
          <img :src="user.avatar_url" alt=''>
        </v-avatar>
      </v-flex>
      <v-flex xs4>
        <div class="subheading">
          <p class="title semibold">{{user.first_name}} {{user.last_name}} ({{user.id}})</p>
          <p><a :href="'mailto:' + user.email">{{user.email}}</a></p>
          <p>Last Log In: {{user.login_at}}</p>
          <p>Last Order: {{user.last_ordered_at}}</p>
          <p>{{user.number_of_orders}} Total Orders</p>
        </div>
      </v-flex>
      <v-flex xs6>
        <login-info :user="user"></login-info>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs6>
        <shipping-address :user="user"></shipping-address>
      </v-flex>
      <v-flex xs6>
        <billing-address :user="user"></billing-address>
      </v-flex>
    </v-layout>
  </div>
</template>

<style lang="sass">
  .avatar
    width: 32px
  .username
    font-weight: 600
    display: inline-block
</style>

<script>
  import api from '@/api/gungho'
  import LoginInfo from '../users/login-info'
  import ShippingAddress from '../users/shipping-address'
  import BillingAddress from '../users/billing-address'

  export default {
    data () {
      return {
        user: false
      }
    },

    metaInfo () {
      return {
        title: this.user ? `Edit: ${this.user.first_name} ${this.user.last_name}` : 'Edit User'
      }
    },

    components: {
      loginInfo: LoginInfo,
      shippingAddress: ShippingAddress,
      billingAddress: BillingAddress
    },

    beforeMount () {
      api.adminUser(this.$route.params.id).then((data) => {
        this.user = data.user
      })
    }
  }
</script>



// WEBPACK FOOTER //
// show.vue?1c7a47e4